import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  surface: {
    maxWidth: '90vw',
    width: '90vw',
    maxHeight: '90vh',
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
  },
  content: {
    flex: '1',
    overflow: 'auto',
    minHeight: 0,
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalS,
    width: '100%',
  },
  closeButton: {
    // Pin the close button to the far right of the title bar regardless of the
    // DialogBody layout (this dialog overrides DialogBody to flex, which would
    // otherwise drop the DialogTitle `action` slot below the title).
    marginLeft: 'auto',
    flexShrink: 0,
  },
});
